<script>
import gmap from '@/library/google-map'
import Tooltip from './tooltip'
import Vue from 'vue'

const icon = '/static/images/map/marker.svg'

export default {
  inject: ['$cluster', '$map'],
  props: {
    lat: {
      type: Number,
      required: true
    },
    lng: {
      type: Number,
      required: true
    }
  },
  google: null,
  marker: null,
  tooltip: null,
  async mounted () {
    await this.$nextTick()
    this.$options.google = await gmap()
    this.init()
  },
  beforeDestroy () {
    this.$options.marker.setMap(null)
  },
  methods: {
    init () {
      setTimeout(() => {
        this.$options.marker = new this.$options.google.maps.Marker({
          position: {lat: this.lat, lng: this.lng},
          icon: icon
        })

        this.$cluster.addMarker(this.$options.marker)
        this.$options.tooltip = new Tooltip(this.$options.marker)

        let component = new Vue({
          render: (h) => h('DIV', this.$slots.default)
        }).$mount()

        this.$options.tooltip.setContent([component.$el])
        this.$options.marker.addListener('click', this.onClick)
      }, 0)
    },
    onClick (e) {
      this.$options.tooltip.show()
      this.$emit('click', e)
    }
  },
  render (h) {
    return null
  }
}
</script>

<style lang="scss">
@import '~@styles/colors/variables';

.infowindow {
  background-color: $color-white;
  padding: 30px 25px;
  border-radius: 5px;

  min-width: 350px;
  width: 350px;
  max-width: 350px;

  transform: translate3d(-50%, calc(-100% - 52px), 0);

  position: relative;

  box-shadow: 0 5px 10px rgba(black, .15);

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;

    height: 100%;
    width: 100%;

    background-image: url('/static/images/elements/element-red-small.svg');
    background-position: bottom 50% right -50%;
    background-repeat: no-repeat;
    background-size: 50%;

    opacity: .3;
  }

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;

    transform: translate(-50%, 40%) rotate(45deg);

    width: 15px;
    height: 15px;
    background: white;

    border-bottom-right-radius: 2px;
  }

  .marker-org {
    user-select: none;
    font-family: 'Gilroy';
    font-size: 20px;
    font-weight: bold;
    max-width: 80%;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/map/marker.vue